export default __webpack_public_path__ + "static/media/icon_handshake.6160cfad.png";